var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCardsForSale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.649,
    height: 29.366
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2187",
    transform: "translate(-20.75 -560.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 331",
    width: 19.149,
    height: 27.866,
    rx: 0.5,
    transform: "translate(21.5 561)",
    fill: "none",
    stroke: "#00b8f1",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "$",
    transform: "translate(26 581.5)",
    fill: "#fff",
    fontSize: 19,
    fontFamily: "SofiaProSoftMedium, Sofia Pro Soft"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$")))));
}

export default SvgIconCardsForSale;